// PurchaseOrderMemo.jsx

import React from 'react';

import PurchaseOrderRichTextSection from 'nodetypes/purchaseorder/view/PurchaseOrderRichTextSection';

/**
 * PurchaseOrderMemo
 *
 * Memo richtext section for the PURCHASE_ORDER viewer.
 */
const PurchaseOrderMemo = React.memo(({
  node,
  nodeType = null,
  readOnly = false,
  onNodeChange = null,
}) => (
  <PurchaseOrderRichTextSection
    node={node}
    nodeType={nodeType}
    readOnly={readOnly}
    onNodeChange={onNodeChange}
    fieldName="memo"
    title="Memo"
    emptyLabel="No memo."
  />
));

PurchaseOrderMemo.displayName = 'PurchaseOrderMemo';

export default PurchaseOrderMemo;
